import axios from "axios";

const messagesCheck = async (chats) => {
  let isOk = true;
  const conversations =
    chats?.data?.filter(
      (e) => e.status === "active" || e.status === "inactive"
    ) ?? [];
  if (conversations.length > 0) {
    const data = conversations?.reduce(
      (obj, item) => ({
        ...obj,
        [item.conversationId]: item?.message?.filter(
          (msg) => msg?.by === "consumer"
        )?.length,
      }),
      {}
    );
    try {
      const response = await axios.post(`/messages-check`, { data });
      if (response.status === 200) {
        isOk = response?.data?.data?.isOk;
      } else {
        throw response.data;
      }
    } catch (error) {
      isOk = false;
      const message = error?.response?.data?.message?.[0]?.value ?? "error";
      console.error(`[Conversations check routine error]: ${message}`);
    }
  }
  return isOk;
};

export default messagesCheck;
